var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-2 ml-md-4 ml-sm-2 mr-4 pb-3" },
    [
      _vm.assistanceSummariesModel.length == 0
        ? _c("custom-result-not-found")
        : _vm._e(),
      _vm._l(_vm.assistanceSummariesModel, function(item, index) {
        return _c(
          "div",
          { key: `attendance-additional-${index}` },
          [
            _c("div", { staticClass: "row bg-secondary-9 rounded p-4 mb-3" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Servicio: ")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "color-black font-16 font-weight-normal pl-2"
                    },
                    [_vm._v(" " + _vm._s(item.serviceDescription) + " ")]
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "col d-flex justify-content-end align-items-center"
                },
                [
                  _c("em", {
                    staticClass: "font-18 cursor-pointer",
                    class: _vm.toggleClass(item.isOpen),
                    on: {
                      click: function($event) {
                        return _vm.onOpenHandler(index)
                      }
                    }
                  })
                ]
              )
            ]),
            _c("validation-provider", {
              attrs: {
                disabled: _vm.getSelectedItems().length > 0,
                rules: "required"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        item.isOpen
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "row bg-secondary-9 rounded py-3 mb-3 mt-n2"
                              },
                              [
                                item.assistanceSummaries.length == 0
                                  ? _c(
                                      "div",
                                      { staticClass: "col" },
                                      [_c("custom-result-not-found")],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._l(item.assistanceSummaries, function(
                                  itemChild,
                                  indexChild
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: `item-index-${indexChild}`,
                                      staticClass: "col-3 mt-3"
                                    },
                                    [
                                      _c("custom-checkbox-single-option", {
                                        staticClass: "check-field",
                                        attrs: {
                                          "custom-error-msg": "",
                                          error:
                                            errors[0] &&
                                            _vm.getSelectedItems().length == 0,
                                          "option-text": _vm.periodDescription(
                                            itemChild
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.setList(itemChild)
                                          }
                                        },
                                        model: {
                                          value: itemChild.selected,
                                          callback: function($$v) {
                                            _vm.$set(itemChild, "selected", $$v)
                                          },
                                          expression: "itemChild.selected"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        errors[0] && item.isOpen
                          ? _c("custom-error", {
                              attrs: {
                                message:
                                  "Favor seleccionar uno o varios periodos para completar el proceso de Documentar comentarios adicionales.",
                                variant: "no-border mb-3"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }